import DisplayCoursesGallery from '@/components/elements/course/gallery/DisplayCoursesGallery';
import DisplayCollectionsGallery from '@/components/elements/doccen-lib/gallery/DisplayCollectionsGallery';
import DisplayDocumentsGallery from '@/components/elements/doccen-lib/gallery/DisplayDocumentsGallery';
import {
  LIBRARY_HIGHLIGHT_COLLECTION,
  LIBRARY_HIGHLIGHT_COURSES,
  LIBRARY_HIGHLIGHT_DOCUMENTS,
} from '@/constant/QueryKeyName';
import { IPaginationResponse } from '@/interfaces/common.interface';
import { IMinimizedCourseItem } from '@/interfaces/course.interface';
import { ICollectionItem } from '@/interfaces/doccen-lib/collection.interface';
import { IMaterialDetail } from '@/interfaces/doccen-lib/contentManagement.interface';
import { getSearchCourses } from 'apis/tms/course.api';
import { postSearchDoccenLibCollection } from 'apis/tms/library/collection.api';
import { postSearchDoccenLibMaterial } from 'apis/tms/library/material.api';
import { AxiosError } from 'axios';
import { PATH_NAME } from 'configs/pathName';
import Divider from 'design-system/components/Divider/Divider';
import { useRouter } from 'next/router';
import { useInfiniteQuery } from 'react-query';
import { EContentType } from 'state/search/LibraryFilterContext';
import EmptyScreen from '../../EmptyScreen';

const DoccenLibrary = () => {
  return (
    <div>
      <HighlightCollectionsWrapper />
      <HighlightDocumentsWrapper />
      <HighlighCoursesWrapper />
    </div>
  );
};

export default DoccenLibrary;

const HighlighCoursesWrapper = () => {
  const query = useInfiniteQuery<
    IPaginationResponse<IMinimizedCourseItem>,
    AxiosError,
    IMinimizedCourseItem
  >({
    queryKey: [LIBRARY_HIGHLIGHT_COURSES, 12],
    queryFn: ({ pageParam = 1 }) =>
      getSearchCourses({
        pageSize: 12,
        pageNumber: pageParam,
        categories: null,
      }),
    select(data) {
      return {
        pageParams: data.pageParams,
        pages: data.pages.map((item) => item.data).flat() || [],
      };
    },
  });

  const router = useRouter();
  if (query.data?.pages.length === 0 && !query.isLoading) return null;

  return (
    <>
      <DisplayCoursesGallery
        urlGenerator={({ id }) => ({
          pathname: PATH_NAME.COURSE_DETAIL,
          query: {
            cid: id,
          },
        })}
        className="space-y-3 p-3 xl:space-y-8 xl:p-5 2xl:px-10 2xl:pb-6 2xl:pt-4"
        title={'Khoá học nổi bật'}
        query={query}
        onClickExpand={() =>
          router.push({
            pathname: PATH_NAME.HOME_FEED_SEARCH,
            query: {
              contentType: EContentType.Course,
              tab: 1,
            },
          })
        }
        notFound={
          <EmptyScreen
            className="py-14 lg:py-24"
            description={'Hiện chưa có khoá học nào.'}
          />
        }
      />
      <div className="px-2 lg:px-0">
        <Divider />
      </div>
    </>
  );
};

const HighlightDocumentsWrapper = () => {
  const query = useInfiniteQuery<
    IPaginationResponse<IMaterialDetail>,
    AxiosError,
    IMaterialDetail
  >(
    [LIBRARY_HIGHLIGHT_DOCUMENTS, 12],
    ({ pageParam = 1 }) =>
      postSearchDoccenLibMaterial({
        pageSize: 12,
        pageNumber: pageParam,
        categories: null,
      }),
    {
      select(data) {
        return {
          pageParams: data.pageParams,
          pages: data.pages.map((item) => item.data).flat() || [],
        };
      },
    }
  );
  const router = useRouter();

  if (query.data?.pages.length === 0 && !query.isLoading) return null;

  return (
    <>
      <DisplayDocumentsGallery
        className="space-y-3 p-3 xl:space-y-8 xl:p-5 2xl:px-10 2xl:pb-6 2xl:pt-4"
        query={query}
        title={'Tài liệu nổi bật'}
        onClickExpand={() =>
          router.push({
            pathname: PATH_NAME.HOME_FEED_SEARCH,
            query: {
              contentType: EContentType.Document,
              tab: 1,
            },
          })
        }
        notFound={
          <EmptyScreen
            className="py-14 lg:py-24"
            description={'Hiện chưa có tài liệu nào.'}
          />
        }
      />
      <div className="px-2 lg:px-0">
        <Divider />
      </div>
    </>
  );
};

const HighlightCollectionsWrapper = () => {
  const query = useInfiniteQuery<
    IPaginationResponse<ICollectionItem>,
    AxiosError,
    ICollectionItem
  >(
    [LIBRARY_HIGHLIGHT_COLLECTION, 8],
    ({ pageParam = 1 }) =>
      postSearchDoccenLibCollection({
        pageSize: 8,
        pageNumber: pageParam,
        categories: null,
      }),
    {
      select(data) {
        return {
          pageParams: data.pageParams,
          pages: data.pages.map((item) => item.data).flat() || [],
        };
      },
    }
  );
  const router = useRouter();

  if (query.data?.pages.length === 0 && !query.isLoading) return null;

  return (
    <>
      <DisplayCollectionsGallery
        className="space-y-3 p-3 xl:space-y-4 xl:p-5 2xl:px-10 2xl:pb-6 2xl:pt-4"
        onClickExpand={() =>
          router.push({
            pathname: PATH_NAME.HOME_FEED_SEARCH,
            query: {
              contentType: EContentType.Collection,
              tab: 1,
            },
          })
        }
        query={query}
        title={'Bộ sưu tập nổi bật'}
        notFound={
          <EmptyScreen
            className="py-14 lg:py-24"
            description={'Hiện chưa có bộ sưu tập nào.'}
          />
        }
      />
      <div className="px-2 lg:px-0">
        <Divider />
      </div>
    </>
  );
};
